import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdiEyeComponent } from './mdi-eye/mdi-eye.component';
import { RequiredMarkComponent } from './required-mark/required-mark.component';

@NgModule({
  declarations: [MdiEyeComponent, RequiredMarkComponent],
  exports: [MdiEyeComponent, RequiredMarkComponent],
  imports: [CommonModule],
})
export class SharedModule {}
